import { render, staticRenderFns } from "./WelcomeView.vue?vue&type=template&id=31044773&scoped=true&"
import script from "./WelcomeView.vue?vue&type=script&lang=ts&"
export * from "./WelcomeView.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeView.vue?vue&type=style&index=0&id=31044773&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31044773",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAlert,VImg})
